// extracted by mini-css-extract-plugin
export default {"editable-cell-value-wrap":"proyecciones-bodega_editable-cell-value-wrap__YPIkl","editable-row":"proyecciones-bodega_editable-row__2DYGJ"};